import { DiaryFormOption } from "./diary-form-option.model";
import { DiaryFormElementType } from "../../constants/diary-form-element-type.enum";
import { DiaryFormElementTranslation } from "./diary-form-element-translation.model";
import { DiaryFormElementMessage } from "./diary-form-element-message.model";
import { DiaryFormElementVisibilityCondition } from "./diary-form-element-visibility-condition.model";

export class DiaryFormElement {
  id: string;
  elementType: DiaryFormElementType;
  orderIndex: number = 0;
  label: string;
  placeholder: string;
  isRequired: boolean = false;
  options: DiaryFormOption[] = [];
  translations: DiaryFormElementTranslation[] = [];
  messages: DiaryFormElementMessage[] = [];
  visibilityConditions: DiaryFormElementVisibilityCondition[] = [];
  defaultVisible: boolean = true;
  visibilityOperator: number | null = null;
  completionOptionId: string | null = null;
  completionValue: string | null = null;
  deleted: boolean = false;
  deletedAt?: Date;
  createdAt: Date = new Date();
  updatedAt?: Date;

  constructor(init?: Partial<DiaryFormElement>) {
    Object.assign(this, init);

    if (init?.createdAt)
      this.createdAt = new Date(init.createdAt);

    // Deep clone options array
    if (init?.options && init.options.length > 0) {
      this.options = init.options.filter(o => !o.deleted).map(o => new DiaryFormOption(o));
    }

    // Deep clone translations array
    if (init?.translations && init.translations.length > 0) {
      this.translations = init.translations.map(t => new DiaryFormElementTranslation(t));
    }

    // Deep clone messages array
    if (init?.messages && init.messages.length > 0) {
      this.messages = init.messages.map(m => new DiaryFormElementMessage(m));
    }

    // Deep clone visibility conditions array
    if (init?.visibilityConditions && init.visibilityConditions.length > 0) {
      this.visibilityConditions = init.visibilityConditions.map(vc => new DiaryFormElementVisibilityCondition(vc));
    }
  }

  name() {
    return this.label
      .replace(/[^\w\s-]/g, '')      // Remove all special characters except space and dash
      .replace(/\s+/g, '-')          // Replace spaces with dashes
      .replace(/-+/g, '-')           // Collapse multiple dashes into a single dash
      .toLowerCase();                // Optional: convert to lowercase
  }
}
